  FroalaEditor.DefineIcon('peeristicsResource', { NAME: 'plus green'});

  FroalaEditor.RegisterCommand('peeristicsResource', {
      title: 'Add resource',
      undo: false,
      focus: true,
      refreshAfterCallback: false,
      callback: function(cmd, source) {
          // Save current cursor/selection
          this.selection.save();

          var form = this.$el.closest('form');
          var modal = $('#modalAddResources');
          modal.attr('data-content-block-type', form.data('type'));
          modal.attr('data-content-block-id', form.data('id'));
          if (form.find('.live-editor').data('editor-config') == 'no_attach')
              modal.attr('data-no-attach', true);
          if (form.attr('data-editor') == null || modal.attr('data-editor') == null || form.attr('data-editor') != modal.attr('data-editor')) {
              var id = Utils.generateUUID();
              form.attr('data-editor', id);
              modal.attr('data-editor', id);
          }
          modal.find('.save-and-view').attr('style', 'display: none !important');
          var activeTab = modal.find('li.modal-add-resources-tab a.active');
          activeTab.removeClass('active');
          modal.find(activeTab.attr('href')).removeClass('in active show');
          var libraryTab = modal.find('#modal-add-resources-library-tab');
          libraryTab.removeClass('d-none').find('a').addClass('active');
          modal.find(libraryTab.find('a').attr('href')).removeClass('d-none').addClass('in active show');
          modal.trigger('data-editor-change');
          if (source == 'imagePaste') {
              modal.find('a[href="#modal-add-resources-files"]').tab('show');
              modal.find('.alert-info[data-type="imagePasted"]').removeClass('d-none');
          }
          modal.modal('show');
      }
  });
